// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"52b25cbf","488":"f4b4354c"}[chunkId] + ".chunk.js";
};